import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 1000,
    },
    dialogTitle: {
      borderBottom: theme.shape.borderGray60,
    },
    dialogContent: {
      backgroundColor: COLORS.gray.gray90,
      padding: theme.spacing(3, 4),
      maxHeight: 'unset',
    },
    description: {
      color: COLORS.gray.black,
      marginBottom: theme.spacing(2),
    },
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(2),
    },
    missingIntegration: {
      color: COLORS.gray.gray30,
      marginTop: theme.spacing(2),
      '& a': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  }),
  { name: 'ConnectIntegrationPopup' }
);
